import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AnalyticsPluginType } from '.';
declare global {
  interface Window {
    appInsights: ApplicationInsights;
  }
}

const ignoredErrors = [
  'ErrorEvent: Script Error',
  'ErrorEvent: Script Error.',
  "Uncaught TypeError: Cannot read properties of null (reading 'parentElement')",
].map((e) => e.toLowerCase());

class AppInsightsPlugin implements AnalyticsPluginType {
  constructor(appInsightsInstrumentationKey: string) {
    window.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: appInsightsInstrumentationKey,
      },
    });

    window.appInsights.loadAppInsights();
    window.appInsights.addTelemetryInitializer(this.filteringFunction);
  }

  filteringFunction = (envelope) => {
    if (
      envelope.baseData &&
      envelope.baseType &&
      envelope.baseType === 'ExceptionData'
    ) {
      const exception = envelope.baseData.exceptions[0];
      if (exception && exception.message) {
        const lowerCaseMessage = exception.message.toLowerCase().trim();
        if (
          !exception.hasFullStack &&
          ignoredErrors.includes(lowerCaseMessage)
        ) {
          return false;
        }
      }
    }
    return true;
  };

  identifyUser(
    userId: string,
    userProperties: Record<string, string | number>
  ) {
    window.appInsights?.setAuthenticatedUserContext(userId);
  }

  isInitialized(): boolean {
    return true;
  }

  resetUser() {
    window.appInsights?.clearAuthenticatedUserContext();
  }

  trackEvent(category: string, action: string) {
    window.appInsights?.trackEvent(
      {
        name: 'event',
      },
      {
        category: category,
        action: action,
      }
    );
  }

  trackPageView(path: string) {
    window.appInsights?.trackPageView({
      name: path,
    });
  }
}

export default AppInsightsPlugin;
